import { render, staticRenderFns } from "./nc-search.vue?vue&type=template&id=fd19c752"
import script from "./nc-search.vue?vue&type=script&lang=js"
export * from "./nc-search.vue?vue&type=script&lang=js"
import style0 from "./nc-search.vue?vue&type=style&index=0&id=fd19c752&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports